import {createRouter, createWebHistory} from "vue-router";
import Home from "./components/home/Home";
import Store from "./components/store/Store";
import Seating from "./components/seating/Seating";
import Summary from "./components/summary/Summary";
import Payment from "./components/payment/Payment";
import PaymentCompleted from "./components/payment/PaymentCompleted";
import Configuration from "./components/configuration/Configuration";

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        /*
        HOME ROUTES
         */
        {
            path: '/',
            name: 'home',
            component: Home,
            props: { locale: window.locale, section: 'home' },
        },
        {
            path: '/fr',
            name: 'fr.home',
            component: Home,
            props: { locale: 'fr', section: 'home' },
        },
        {
            path: '/en',
            name: 'en.home',
            component: Home,
            props: { locale: 'en', section: 'home' },
        },

        /*
        TICKETS SELECTION ROUTES
         */
        {
            path: '/fr/billets',
            name: 'fr.tickets',
            component: Store,
            props: { locale: 'fr', section: 'ticketing' },
        },
        {
            path: '/en/tickets',
            name: 'en.tickets',
            component: Store,
            props: { locale: 'en', section: 'ticketing' },
        },

        /*
        SEATING SELECTION ROUTES
         */
        {
            path: '/fr/sieges',
            name: 'fr.seating',
            component: Seating,
            props: { locale: 'fr', section: 'seating' },
        },
        {
            path: '/en/seating',
            name: 'en.seating',
            component: Seating,
            props: { locale: 'en', section: 'seating' },
        },

        /*
        PURCHASE SUMMARY ROUTES
         */
        {
            path: '/fr/sommaire',
            name: 'fr.summary',
            component: Summary,
            props: { locale: 'fr', section: 'summary' },
        },
        {
            path: '/en/summary',
            name: 'en.summary',
            component: Summary,
            props: { locale: 'en', section: 'summary' },
        },

        /*
        PAYMENT ROUTES
         */
        {
            path: '/fr/paiement',
            name: 'fr.payment',
            component: Payment,
            props: { locale: 'fr', section: 'payment' },
        },
        {
            path: '/en/payment',
            name: 'en.payment',
            component: Payment,
            props: { locale: 'en', section: 'payment' },
        },

        /*
        PAYMENT COMPLETED ROUTES
         */
        {
            path: '/fr/achat-termine',
            name: 'fr.purchase-completed',
            component: PaymentCompleted,
            props: { locale: 'fr', section: 'purchase-completed' },
        },
        {
            path: '/en/purchase-completed',
            name: 'en.purchase-completed',
            component: PaymentCompleted,
            props: { locale: 'en', section: 'purchase-completed' },
        },

        /*
        CONFIGURATION ROUTES
         */
        {
            path: '/fr/configuration',
            name: 'fr.configuration',
            component: Configuration,
            props: { locale: 'fr' },
        },
        {
            path: '/en/configuration',
            name: 'en.configuration',
            component: Configuration,
            props: { locale: 'en', section: 'configuration' },
        }
    ]
});
